import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  label: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  /** Destino del botón. Por defecto lleva a la última sección de la página (el cierre de compra). */
  href?: string;
}
export function CtaButton({
  label,
  size = 'md',
  fullWidth = false,
  href = '#comprar'
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-9 py-5 text-lg md:text-xl' : 'px-7 py-4 text-base md:text-lg';
  const isExternal = !href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isExternal) {
      // En previsualizaciones dentro de un iframe, target="_blank" puede bloquearse.
      // Forzamos la navegación al nivel superior de la ventana.
      event.preventDefault();
      const opened = window.open(href, '_blank', 'noopener,noreferrer');
      if (!opened) {
        try {
          if (window.top) {
            window.top.location.href = href;
            return;
          }
        } catch {
          // Acceso al top bloqueado por origen cruzado: navegamos en la ventana actual.
        }
        window.location.href = href;
      }
      return;
    }
    const target = document.querySelector(href);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-terracotta font-semibold text-white shadow-[0_2px_0_0_#B85C3E] transition-[transform,background-color,box-shadow] duration-150 ease-smooth hover:bg-terracotta-dark hover:-translate-y-0.5 active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${sizeClasses} ${fullWidth ? 'w-full' : ''}`} data-id="element-26" data-mp="3juksb1chvu2w">
      <span data-id="element-27" data-mp="3mxqm84q4n2k5">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="3hydzdjz99vhk" />
    </a>;
}